import {
	iconLocationHeader,
	iconSupportHeader,
	iconTelephone,
} from '../../assets/icons/index.js';
import logo from 'assets/icons/logo.jpg';
import classNames from 'classnames';
// import NotificationAndCount from 'components/common/NotificationAndCount';
import { AppRoutes } from 'constants/appRoutes';
import { getAuth } from 'functions';
import useDevice from 'hooks/useDevice';
import React, { useState } from 'react';
import styled from 'styled-components';
import { Tooltip } from 'antd';
// import NotificationSideBar from 'components/Notification/NotificationSideBar';
// import ModalBranch from 'components/common/Modal/ModalBranch';
import LinkToCallMobile from 'components/LinkToCallMobile';
import { useNavigate } from 'react-router-dom';

const ChatStyled = styled.div`
	.chat-online-status {
		position: relative;
		.status {
			position: absolute;
			right: -5px;
			top: -1px;
			height: 4px;
			width: 4px;
			border-radius: 50%;
			overflow: hidden;
			&.online {
				background-color: #009565;
			}
		}
	}
`;

export default function Header({ className, openContactUs }) {
	const navigate = useNavigate();
	const [openNotification, setOpenNotification] = useState(false);
	const [openBranch, setOpenBranch] = useState(false);
	const { isMobile } = useDevice();
	const auth = getAuth();
	const isAdmin = !!auth?.admin;

	const onOpenNotifications = () => setOpenNotification(true);

	const clickToHome = () => {
		navigate(AppRoutes.home);
	};

	return (
		<div
			className={classNames({
				'flex justify-between items-start h-72px px-24px py-15px': true,
				[`${className}`]: className,
			})}
		>
			<div className='cursor-pointer hover:opacity-80' onClick={clickToHome}>
				<img
					src={logo}
					alt='login-logo'
					className={classNames({
						'w-180px md:w-244px': true,
						// 'ml-16px': isAdmin && isMobile,
					})}
				/>
			</div>

			<div className='flex items-center leading-14px'>
				{!isMobile && (
					<div className='flex items-center leading-14px gap-13px'>
						<ChatOnline status='online' />
						<div className='w-1px h-13px bg-white opacity-25'></div>
						<Contact auth={auth} openContactUs={openContactUs} />
						<div className='w-1px h-13px bg-white opacity-25'></div>
						<Item
							content='Chi nhánh BVNT'
							icon={iconLocationHeader}
							onClick={() => {
								window.open('https://www.baovietnhantho.com.vn/chi-nhanh');
							}}
						/>
					</div>
				)}

				{/* <div className='ml-18px hover:opacity-80'>
					<NotificationAndCount onOpenNotifications={onOpenNotifications} />
				</div> */}
			</div>
			{/* {openNotification && (
				<NotificationSideBar onClose={() => setOpenNotification(false)} />
			)} */}
			{/* {openBranch && (
				<ModalBranch isShow={openBranch} onClose={() => setOpenBranch(false)} />
			)} */}
		</div>
	);
}

const Item = ({ content, onClick }) => {
	return (
		<div
			className='flex items-center cursor-pointer hover:opacity-80'
			onClick={onClick}
		>
			<div className='flex flex-col text-12px leading-14px text-white'>
				{content}
			</div>
		</div>
	);
};

const ChatOnline = ({ status }) => {
	return (
		<ChatStyled>
			<Item
				content={
					<div className='chat-online-status'>
						<a
							href='https://zalo.me/3157969611052484595'
							target={'_blank'}
						>
							Chat online
						</a>
						<div
							className={classNames({
								status: true,
								online: status === 'online',
							})}
						></div>
					</div>
				}
				icon={iconLocationHeader}
				onClick={() => {}}
			/>
		</ChatStyled>
	);
};

const Contact = () => {
	return (
		<Item
			content={
				<Tooltip
					overlayClassName='tooltip-contact'
					placement='bottomRight'
					title={
						<>
							<div className='flex flex-col items-center'>
								<div className='flex items-center gap-4px'>
									<img src={iconTelephone} alt='' width={18} />
									<LinkToCallMobile href='tel:1900558899'>
										<p className='font-averta-semibold text-21px text-AD7B18 leading-26px'>
											*1166
										</p>
									</LinkToCallMobile>
								</div>
							</div>
							<div className='border-b border-F0F0F0 mt-14px mb-11px'></div>
							<div className='flex flex-col items-center'>
								<div className='flex items-center gap-4px'>
									<img src={iconTelephone} alt='' width={18} />
									<LinkToCallMobile href='tel:18006966'>
										<p className='font-averta-semibold text-21px text-AD7B18 leading-26px'>
											1800-6966
										</p>
									</LinkToCallMobile>
								</div>
								<p className='text-8291AB text-12px leading-14px text-center'>
									* Miễn phí với số điện thoại đã đăng ký trên hợp đồng Bảo Việt
									Nhân thọ
								</p>
							</div>
						</>
					}
				>
					<div className='inline-flex items-center gap-6px'>
						<span>Liên hệ</span>
						<div className='triangle_down-white'></div>
					</div>
				</Tooltip>
			}
			icon={iconSupportHeader}
		/>
	);
};
